import { cva } from '@/styled-system/css';

export const upsellBannerRootRecipe = cva({
  base: {
    'display': 'flex',
    'flexDirection': {
      lgDown: 'column',
    },
    'alignItems': {
      lg: 'center',
    },
    'justifyContent': {
      lg: 'center',
    },
    'borderRadius': 'UpsellBanner.Root',
    'paddingBlock': 'UpsellBanner.Root.padding.vert',
    'paddingInline': 'UpsellBanner.Root.padding.horz',
    'paddingInlineStart': {
      lgDown:
        'calc({spacing.UpsellBanner.Root.gap.leading} + {sizes.UpsellBanner.Media.icon.width} + {spacing.UpsellBanner.Root.gap.trailing})',
    },
    'position': 'relative',

    '&:has([data-c11n-component="UpsellBanner.CloseButton"]) [data-c11n-component="UpsellBanner.Media"]':
      {
        marginInlineStart: {
          lg: 'auto',
        },
      },
  },
  variants: {
    tone: {
      neutral: {
        backgroundColor: 'UpsellBanner.Root.neutral.bg.default',
      },
      soft: {
        backgroundColor: 'UpsellBanner.Root.soft.bg',
      },
      hero: {
        backgroundColor: 'UpsellBanner.Root.hero.bg',
      },
      impact: {
        backgroundColor: 'UpsellBanner.Root.impact.bg',
      },
    },
  },
});
